module.exports = __webpack_public_path__ + "static/media/404.551f9f2b.png";